import React, { useContext, useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faJoint, faPhone, faUnlock } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { SellerContext } from "../../lib/context";
import { responseNotification } from "../../utils/notify";
import Link from "antd/lib/typography/Link";
import { useCookies } from "react-cookie";
import { Statistic, Row, Col } from "antd";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { renderTime } from "./ContDownTimer";
import { type } from "node:os";
import { redirect } from "../../utils";
import nookies from "nookies";

library.add(faPhone, faUnlock);

interface VerifyProps {
  data: any;
  sendOtp: () => void;
}

const Verify = ({ data, sendOtp }: VerifyProps) => {
  const { register, handleSubmit, errors } = useForm();
  const [loading, setLoading] = useState(false);
  const { infos, setInfos } = useContext(SellerContext);
  const [cookie, setCookie] = useCookies(["sellerToken"]);
  const [error, setError] = useState();
  const [time, setTime] = useState(300);
  const [showTimer, setShowTimer] = useState(true);
  const [showTimerAlt, setShowTimerAlt] = useState(true);

  const onSubmit = (formData) => {
    setLoading(true);
    try {
      fetch(`${process.env.NEXT_PUBLIC_AUTH_API}/registration`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          mobileNumber: `+88${data.mobileNumber}`,
          firstName: data?.firstName,
          lastName: data?.lastName,
          otp:
            formData?.otp1 + formData?.otp2 + formData?.otp3 + formData?.otp4,
          password: data?.password,
        }),
      })
        .then((data) => data.json())
        .then((data) => {
          setLoading(false);
          if (data?.token) {
            setInfos({
              userName: data?.mobileNumber,
            });
            // setCookie("sellerToken", JSON.stringify(data.token), {
            //   path: "/",
            //   maxAge: 7 * 24 * 60 * 60, // Expires after
            //   sameSite: "strict",
            // });
            // nookies.set(null, "sellerToken", data.token, {
            //   path: "/",
            //   maxAge: 7 * 24 * 60 * 60, // Expires after
            //   sameSite: "strict",
            // });
            redirect("/");
          } else {
            responseNotification(data?.message, "error");
          }
        });
    } catch (e) {
      setLoading(false);
      responseNotification(e?.message || "Login failed");
    }
  };

  const setOtpResendTime = () => setTime(time - 1);

  useEffect(() => setError(error), [errors]);

  useEffect(() => {
    if (time > 0) {
      setTimeout(() => setOtpResendTime(), 1000);
    } else {
      setShowTimer(false);
    }
  }, [time]);

  useEffect(() => {
    if (showTimer) {
      setShowTimerAlt(true);
    } else {
      setShowTimerAlt(false);
    }
  }, [showTimer]);

  //   const { Countdown } = Statistic;
  // const deadline = Date.now() + 1000 * 60 * 60 * 24 * 2 + 1000 * 30; // Moment is also OK

  // function onFinish() {
  //   console.log('finished!');
  // }

  // function onChange(val) {
  //   if (4.95 * 1000 < val && val < 5 * 1000) {
  //     console.log('changed!');
  //   }
  // }

  //////

  //////
  function OTPInput() {
    const inputs = document.querySelectorAll("#otp > *[id]");
    for (let i = 0; i < inputs.length; i++) {
      (inputs[i] as any).addEventListener("keydown", function (event: any) {
        if (event.key === "Backspace") {
          (inputs[i] as any).value = "";
          if (i !== 0) (inputs[i - 1] as any).focus();
        } else {
          if (i === inputs.length - 1 && (inputs[i] as any).value !== "") {
            return true;
          } else if (event.keyCode > 47 && event.keyCode < 58) {
            (inputs[i] as any).value = event.key;
            if (i !== inputs.length - 1) (inputs[i + 1] as any).focus();
            event.preventDefault();
          } else if (event.keyCode > 64 && event.keyCode < 91) {
            (inputs[i] as any).value = String.fromCharCode(event.keyCode);
            if (i !== inputs.length - 1) (inputs[i + 1] as any).focus();
            event.preventDefault();
          }
        }
      });
    }
  }
  OTPInput();

  return (
    <div className="row">
      <div className=" "></div>
      <div className="bg-white p-6 text-center font-sans-ui-serif mb-0">
        <h2>
          <b className="become ">BECOME A</b>
        </h2>
        <h2 className="seller">JACHAI MERCHANT</h2>
      </div>
      <div className="col-span-12 lg:col-span-4 intro-y dstyle">
        <div className="row">
          <form onSubmit={handleSubmit(onSubmit)} className="bg-white p-5">
            <div className="okcreate">
              <h2 className="text-center text-2xl">Verification</h2>
            </div>

            <div className="mt-2 h-14 w-86 bg-grey">
              <h2 className=" text-center style">
                Enter 4 digit verification code that we have sent to
              </h2>
              <h2 className="mt-2 text-center style"> {data?.mobileNumber}.</h2>
            </div>
            <div className="cmargin">
              {showTimerAlt ? (
                <CountdownCircleTimer
                  isPlaying
                  duration={time}
                  colors={[
                    ["#004777", 0.33],
                    ["#F7B801", 0.33],
                    ["#A30000", 1],
                  ]}
                >
                  {renderTime}
                </CountdownCircleTimer>
              ) : undefined}
            </div>

            {/* <Row gutter={16}>
          <Col span={12}>
           <Countdown style={{marginLeft:160}} title="" value={Date.now() + 10 * 1000} onChange={onChange} />
          </Col>
            </Row> */}

            {/* <div className=" mt-8 border text-current luser h-48">
              <input
                name="otp"
                ref={register({ required: 'Otp is required!' })}
              />
            </div> */}
            <div className=" mt-6 text-center">
              <div id="otp" className="flex justify-center">
                <input
                  className="m-2 text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
                  type="text"
                  id="first"
                  name="otp1"
                  maxLength={1}
                  ref={register({ required: "Otp is required!" })}
                />
                <input
                  className="m-2 text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
                  type="text"
                  id="second"
                  name="otp2"
                  maxLength={1}
                  ref={register({ required: "Otp is required!" })}
                />
                <input
                  className="m-2 text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
                  type="text"
                  id="third"
                  name="otp3"
                  maxLength={1}
                  ref={register({ required: "Otp is required!" })}
                />
                <input
                  className="m-2 text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
                  type="text"
                  id="fourth"
                  name="otp4"
                  maxLength={1}
                  ref={register({ required: "Otp is required!" })}
                />
              </div>
            </div>
            <p className="highlighted-txt">{errors?.otp?.message}</p>
            <div className="mt-10 h-8 w-86 ">
              {time ? undefined : (
                <h2
                  className=" text-center highlighted-txt resend"
                  onClick={() => (sendOtp(), setTime(300), setShowTimer(true))}
                >
                  Resend OTP
                </h2>
              )}
            </div>

            <div className="bt">
              <button type="submit" className="bstyle">
                Verify OTP
              </button>
            </div>
          </form>
          <div className="create">
            <h2 className="fcreate">
              Already a member? <Link href="/login"> Sign in</Link>
            </h2>
          </div>
        </div>
      </div>
      {/* </form> */}
    </div>
  );
};

export default Verify;
